import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Repo } from "types/generated";
import { downloadFileFromURL } from "utils/file";
import { getRepoDownloadUrl } from "utils/spaceliftRepo";

import { showDeleteSpaceliftVcsRepoConfirmation } from "../../DeleteConfirmation";
import { showEditSpaceliftVcsRepoDrawer } from "../../EditDrawer";

const SpaceliftVcsReposTableRowActionsCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<Repo>) => {
  const latestRevisionSha = repo.revisions.edges[0]?.node.sha;

  const handleDownload = () => {
    if (latestRevisionSha) {
      downloadFileFromURL(getRepoDownloadUrl(repo.slug, latestRevisionSha));
    }
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Repo actions">
        <CopyFieldDropdownMenuItem title="Copy ID" value={repo.id} />
        <DropdownMenuItem
          onAction={handleDownload}
          isDisabled={!latestRevisionSha}
          tooltip={!latestRevisionSha ? "No commits to download" : undefined}
          tooltipPlacement="left"
        >
          Download
        </DropdownMenuItem>
        <DropdownMenuItem onAction={() => showEditSpaceliftVcsRepoDrawer({ repo })}>
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          onAction={() => showDeleteSpaceliftVcsRepoConfirmation({ id: repo.id, name: repo.name })}
          danger
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableRowActionsCell;
